"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomButtons = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _SearchConfigurationProvider = require("../../../containers/SearchConfigurationProvider");
var _models = require("../../../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.background.paper,
  borderRadius: 21,
  boxShadow: _mui.SHADOW_LEVEL1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  justifyContent: 'center',
  width: 42
}));
const ZoomButtons = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    setViewSettings
  } = (0, _SearchConfigurationProvider.useSearchConfiguration)();
  const zoomIn = (0, _react.useCallback)(() => setViewSettings(p => ({
    ...p,
    zoom: p.zoom + 1
  })), [setViewSettings]);
  const zoomOut = (0, _react.useCallback)(() => setViewSettings(p => ({
    ...p,
    zoom: p.zoom - 1
  })), [setViewSettings]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    "data-testid": getTestId(_models.TestId.SelectPickupPointDialogZoomButtons),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      color: "default",
      size: "large",
      variant: "text",
      onClick: zoomIn,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Add, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      color: "default",
      size: "large",
      variant: "text",
      onClick: zoomOut,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Remove, {})
    })]
  });
};
exports.ZoomButtons = ZoomButtons;